var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheveronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7532.33,-256.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron_left-black",
    transform: "matrix(0.145417,0,0,0.186342,7128.81,197.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49023.3,-1059.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7542.97,272.006C7542.77,272.213 7542.72,272.524 7542.85,272.773L7542.86,272.79L7542.86,272.806L7542.87,272.821L7542.88,272.836L7542.89,272.851L7542.91,272.872L7542.92,272.885L7542.93,272.898L7542.94,272.911L7542.95,272.924L7542.96,272.937L7542.97,272.949C7542.97,272.949 7552.75,282.724 7552.75,282.724C7553.01,282.985 7553.43,282.985 7553.69,282.724C7553.95,282.464 7553.95,282.042 7553.69,281.782L7544.39,272.478L7553.69,263.174C7553.95,262.913 7553.95,262.491 7553.69,262.231C7553.43,261.971 7553.01,261.971 7552.75,262.231L7542.97,272.006Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveronLeft);
export default __webpack_public_path__ + "static/media/cheveron_left.ff934b22ab72c696d2000d6ac6fc2924.svg";
export { ForwardRef as ReactComponent };